import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DisableBlacklistElementMutation,
  DisableBlacklistElementMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { blacklistElementFragment } from "src/graphql/anti-fraud/fragments/BlacklistElementFragment.ts";
import { usePerformMutation } from "src/graphql/utils";

export const disableBlacklistElement = gql`
  mutation DisableBlacklistElement($id: ID!) {
    disableBlacklistElement(id: $id) {
      ...BlacklistElement
    }
  }

  ${blacklistElementFragment}
` as TypedDocumentNode<DisableBlacklistElementMutation, DisableBlacklistElementMutationVariables>;

export const useDisableBlacklistElementMutation = ({ onSuccess }) => {
  return usePerformMutation(disableBlacklistElement, {
    onSuccess: (data) => {
      onSuccess(data?.disableBlacklistElement);
    },
  });
};
